// extracted by mini-css-extract-plugin
export default {"inactive":"steps_inactive__7JpZL","form-control":"steps_form-control__NGUpR","form-select":"steps_form-select__Gmiaq","form-wrapper":"steps_form-wrapper__pOBa5"};